var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.25 4H2.5C2.10218 4 1.72064 4.15804 1.43934 4.43934C1.15804 4.72064 1 5.10218 1 5.5V12.25C1 12.6478 1.15804 13.0294 1.43934 13.3107C1.72064 13.592 2.10218 13.75 2.5 13.75H9.25C9.64782 13.75 10.0294 13.592 10.3107 13.3107C10.592 13.0294 10.75 12.6478 10.75 12.25V11.5",
    stroke: "#8F8F8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 2.50008L12.25 4.75008M13.2888 3.68883C13.5841 3.39345 13.7501 2.99282 13.7501 2.57508C13.7501 2.15734 13.5841 1.75672 13.2888 1.46133C12.9934 1.16595 12.5927 1 12.175 1C11.7573 1 11.3566 1.16595 11.0613 1.46133L4.75 7.75008V10.0001H7L13.2888 3.68883Z",
    stroke: "#8F8F8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3b43594ffa821544af220f6b4adf4a4.svg";
export { ForwardRef as ReactComponent };